<template>
  <b-columns is-fluid>
    <b-column>
      <h2 class="is-size-3">Material portal - {{ resourceTypeHeader }}</h2>
      <div class="box is-radiusless">
        <div
          v-if="loadingResource"
          class="has-text-centered"
        >
          <font-awesome-icon
            icon="atom"
            spin
            size="2x"
          />
        </div>
        <component
          v-else
          :is="resourceComponentName"
          :data="getMaterialPortalResource"
        />
      </div>
    </b-column>
  </b-columns>
</template>

<script>
import Detector from '@/components/material/Detector'
import Ppe from '@/components/material/Ppe'
import SamplingType from '@/components/material/SamplingType'
import Decontamination from '@/components/material/Decontamination'
import { mapGetters, mapActions } from 'vuex'

import { CLEAR_RESOURCE } from '@/store/mutation-types'

export default {
  name: 'Material',
  components: {
    Detector,
    Ppe,
    SamplingType,
    Decontamination
  },
  props: {
    resourceType: {
      type: String,
      required: true
    },
    resourceId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getResourceUrl',
      'getMaterialPortalResource',
      'loadingResource'
    ]),
    resourceComponentName () {
      switch (this.resourceType) {
        case 'sampling_type': return 'sampling-type'
        default: return this.resourceType
      }
    },
    resourceTypeHeader () {
      switch (this.resourceType) {
        case 'ppe': return 'Personal Protection Equipment'
        case 'decontamination': return 'Decontamination instruction'
        case 'detector': return 'Detector manual'
        case 'sampling_type': return 'Sampling instruction'
        default: return null
      }
    }
  },
  created () {
    this.fetchResource({ resourceType: this.resourceType, resourceId: this.resourceId })
  },
  destroyed () {
    this.$store.commit(CLEAR_RESOURCE)
  },
  methods: {
    ...mapActions(['fetchResource'])
  }
}
</script>

<style>

</style>
